<script setup lang="ts">
    import 'highlight.js/styles/stackoverflow-light.css'
    import 'highlight.js/lib/common'
    import Highlight from '@highlightjs/vue-plugin'

    const props = defineProps<{
        code: unknown
        language: string
    }>()

    const hasCode = computed(() => {
        if (typeof props.code === 'string') {
            return props.code
        }
        return JSON.stringify(props.code, null, 2)
    })
</script>

<template>
    <Highlight.component
        :code="hasCode"
        :language="language"
        class="whitespace-pre font-mono leading-snug text-smaller" />
</template>
